import React, { useContext } from "react"
import { RadioButtonsRow } from "components/StraightThroughVehicleComp/1_Vehicle/AddVehicleBody/5_VehicleLeasedFinanced/RadioButtonsRow/RadioButtonsRow"
import DropdownRow from "components/StraightThroughVehicleComp/1_Vehicle/AddVehicleBody/5_VehicleLeasedFinanced/DropdownRow/DropdownRow"
import TooltipModal from "components/StraightThroughVehicleComp/1_Vehicle/AddVehicleBody/5_VehicleLeasedFinanced/TooltipModal/TooltipModal"
import VehicleRegistrantList from "components/StraightThroughVehicleComp/Dropdowns/VehicleRegistrantList"
import VehicleUseList from "components/StraightThroughVehicleComp/Dropdowns/VehicleUseList"
import EstimatedMileageList from "components/StraightThroughVehicleComp/Dropdowns/EstimatedMileageList"
import OtherDeductibleList from "components/StraightThroughVehicleComp/Dropdowns/OtherDeductibleList"
import CollisionTypeList from "components/StraightThroughVehicleComp/Dropdowns/CollisionTypeList"
import CollisionDeductibleList from "components/StraightThroughVehicleComp/Dropdowns/CollisionDeductibleList"
import DaysDrivenList from "components/StraightThroughVehicleComp/Dropdowns/DaysDrivenList"
import HelpfulDocumentsNJ from "./HelpfulDocumentsNJ/HelpfulDocumentsNJ"
import HelpfulDocumentsPA from "./HelpfulDocumentsPA/HelpfulDocumentsPA"
import DropdownRowWSearchFilter from "./DropdownRowWSearchFilter/DropdownRowWSearchFilter"
import VehicleLeaseFinanceList from "components/StraightThroughVehicleComp/Dropdowns/VehicleLeaseFinanceList"

const EndorsementVehicleLeasedFinanced = ({ policyStateAbbr, requestContext, vehicleContext, endorsementClassStr }) => {
    const context = useContext(requestContext);
    const { newVehicle, setNewVehicle, modal, validateVehicles_3 } = useContext(vehicleContext);

    // Only render the form if the vehicle is leased or financed
    if (newVehicle?.vehicleOwnedLeasedFinanced?.toLowerCase() === "owned") {
        return null;
    }

    // Resets collision deductible for collision type selection
    const setsCollision = (value) => {
        setNewVehicle(prev => ({ ...prev, collisionType: value }))
        setNewVehicle(prev => ({ ...prev, collisionDeductible: "" }))
    }

    const type = newVehicle?.vehicleOwnedLeasedFinanced?.toLowerCase() === "leased" ? "leased" : "financed";
    // Tooltips
    const tooltips = {
        comprehensiveDeductible: {
            title: "\"Other than Collision\" (Comprehensive)",
            content: "\"Other than Collision\" (Comprehensive) covers your vehicle, and sometimes other vehicles you may be driving, for losses resulting from incidents other than collision. For example, \"Other than Collision\" (Comprehensive) insurance covers damage to your car if it is stolen, or damaged by flood, fire, or animals. It pays to fix your vehicle less the deductible you choose. To keep your premiums low, select as high a deductible as you feel comfortable paying out of pocket. Coverage is limited to the terms and conditions contained in the policy."
        },
        collisionOptions: {
            title: "What are the options for Collision coverage?",
            content: (
                <>
                    <strong>Broad Collision</strong>: Pays for damages to your vehicle that was damaged regardless of fault, with a deductible that applies only if you are more than 50% at fault <br /><br />
                    <strong>Standard Collision</strong>: Pays for damages to your vehicle that was caused regardless of fault, with a deductible that always applies. <br /><br />
                    <strong>Limited Collision</strong>: Pays for damage to your vehicle if you are less than 50% at fault for an accident. If you are 50% or more at fault Collision coverage for this option will not apply to repair your vehicle.
                </>
            )
        },
        collisionDeductible: {
            title: "Collision Coverage",
            content: "Collision covers damage to your car when your car hits, or is hit by, another vehicle, or other object. This coverage pays to fix your vehicle less the deductible you choose. To keep your premiums low, select as large a deductible as you feel comfortable paying out of pocket. Coverage is limited to the terms and conditions contained in the policy."
        },
        rentalReimbursement: {
            title: "Rental Reimbursement",
            content: "Rental Reimbursement pays for the cost of a rental car if you can't drive the insured vehicle due to theft or damage from an accident. Extended Transportation coverage cannot be purchased unless the car is covered under 'Other than Collision' (Comprehensive) coverage. Coverage is limited to the terms and conditions contained in the policy."
        }
    }

    const rentalReimbursementOptions = {
        "MI":
            <>
                <option value="" disabled>Select from the following...</option>
                <option value="$30 per day/ $900 max">$30 per day/ $900 max</option>
                <option value="$40 per day/ $1,200 max">$40 per day/ $1,200 max</option>
                <option value="None">None</option>
            </>,
        "NJ":
            <>
                <option value="" disabled>Select from the following...</option>
                <option value="$15 per day/ $450 max">$15 per day/ $450 max</option>
                <option value="$30 per day/ $900 max">$30 per day/ $900 max</option>
                <option value="$40 per day/ $1,200 max">$40 per day/ $1,200 max</option>
                <option value="$50 per day/ $1,500 max">$50 per day/ $1,500 max</option>
                <option value="None">None</option>
            </>,
        "PA":
            <>
                <option value="" disabled>Select from the following...</option>
            </>
    }

    return (
        <form className="col-xl-12 justify-content-center" style={{ margin: "0 0.5rem", padding: "0 0.75rem" }}>
            <RadioButtonsRow
                name={type === 'leased' ? "vehicleIsCoLeased" : "vehicleIsCoOwned"}
                question={`Is this vehicle co-${type === 'leased' ? 'leased' : 'owned'}?*`}
                value={newVehicle[type === 'leased' ? "vehicleIsCoLeased" : "vehicleIsCoOwned"]}
                onChange={(e) => setNewVehicle(prev => ({ ...prev, [type === 'leased' ? "vehicleIsCoLeased" : "vehicleIsCoOwned"]: e.target.value }))}
            />
            <DropdownRowWSearchFilter
                name={type === 'leased' ? "vehicleLeasingCompany" : "vehicleFinanceCompany"}
                question={`${type === 'leased' ? 'Leasing' : 'Financing'} Company Name:*`}
                options={VehicleLeaseFinanceList(type)}
                value={newVehicle[type === 'leased' ? "vehicleLeasingCompany" : "vehicleFinanceCompany"]}
                onChange={(e) => setNewVehicle(prev => ({ ...prev, [type === 'leased' ? "vehicleLeasingCompany" : "vehicleFinanceCompany"]: e.value }))}
            />
            <RadioButtonsRow
                name="garaged"
                question={`Is this vehicle primarily kept at ${context[endorsementClassStr].policyAddressFields.address1}, ${context[endorsementClassStr].policyAddressFields.city}, ${context[endorsementClassStr].policyAddressFields.state}, ${context[endorsementClassStr].policyAddressFields.zip}?*`}
                value={newVehicle.garaged}
                onChange={(e) => setNewVehicle(prev => ({ ...prev, garaged: e.target.value }))}
            />
            <DropdownRow
                name="vehicleRegistrant"
                question="In what name is this vehicle registered, or going to be registered?*"
                options={<VehicleRegistrantList />}
                value={newVehicle.vehicleRegistrant}
                onChange={(e) => setNewVehicle(prev => ({ ...prev, vehicleRegistrant: e.target.value }))}
            />
            <RadioButtonsRow
                display={["NJ", "PA"].includes(policyStateAbbr)}
                name={policyStateAbbr == "NJ" ? "vehicleIsNJ" : "vehicleIsPA"}
                question={`Is this vehicle registered in the state of ${policyStateAbbr == "NJ" ? "New Jersey" : "Pennsylvania"}?*`}
                value={policyStateAbbr == "NJ" ? newVehicle.vehicleIsNJ : newVehicle.vehicleIsPA}
                onChange={(e) => policyStateAbbr == "NJ" ? setNewVehicle(prev => ({ ...prev, vehicleIsNJ: e.target.value })) : setNewVehicle(prev => ({ ...prev, vehicleIsPA: e.target.value }))}
            />
            <DropdownRow
                name="vehicleUse"
                question="How will this vehicle be used?*"
                options={<VehicleUseList state={context?.userData?.state} />}
                value={newVehicle.vehicleUse}
                onChange={(e) => setNewVehicle(prev => ({ ...prev, vehicleUse: e.target.value }))}
            />
            <DropdownRow
                display={["NJ", "PA"].includes(policyStateAbbr)}
                name="daysDrivenPerWeek"
                question="Days Driven per Week:*"
                options={<DaysDrivenList />}
                value={newVehicle.daysDrivenPerWeek}
                onChange={(e) => setNewVehicle(prev => ({ ...prev, daysDrivenPerWeek: e.target.value }))}
            />
            <DropdownRow
                display={["MI"].includes(policyStateAbbr)}
                name="estimatedMileage"
                question="Estimated Annual Mileage:*"
                options={<EstimatedMileageList />}
                value={newVehicle.estimatedMileage}
                onChange={(e) => setNewVehicle(prev => ({ ...prev, estimatedMileage: e.target.value }))}
                defaultValue="9,001-12,000"
            />
            <DropdownRow
                display={["MI"].includes(policyStateAbbr)}
                name="otherDeductible"
                question='Choose your "Other than Collision" (Comprehensive) deductible.*'
                options={<OtherDeductibleList />}
                value={newVehicle.otherDeductible}
                onChange={(e) => setNewVehicle(prev => ({ ...prev, otherDeductible: e.target.value }))}
                onTooltipClick={() => modal.openModal(tooltips.comprehensiveDeductible.title, tooltips.comprehensiveDeductible.content)}
            />
            <RadioButtonsRow
                display={["NJ"].includes(policyStateAbbr)}
                name="otherDeductible"
                question='Choose your "Other than Collision" (Comprehensive) deductible.*'
                options={[
                    { value: "$750", label: "$750" }
                ]}
                noteContent={"If you are interested in a deductible other than the standard $750, you will be required to sign a new Coverage Selection Form. Please call 800-535-2873 to speak to a CURE representative."}
                alignItemsCenter={false}
                value={newVehicle.otherDeductible}
                onChange={(e) => setNewVehicle(prev => ({ ...prev, otherDeductible: e.target.value }))}
                onTooltipClick={() => modal.openModal(tooltips.comprehensiveDeductible.title, tooltips.comprehensiveDeductible.content)}
            />
            <RadioButtonsRow
                display={["PA"].includes(policyStateAbbr)}
                name="otherDeductible"
                question='Choose your "Other than Collision" (Comprehensive) deductible.*'
                options={[
                    { value: "$500", label: "$500" }
                ]}
                noteContent={"If you are interested in a deductible other than the standard $500, you will be required to sign a new Coverage Selection Form. Please call 800-535-2873 to speak to a CURE representative."}
                alignItemsCenter={false}
                value={newVehicle.otherDeductible}
                onChange={(e) => setNewVehicle(prev => ({ ...prev, otherDeductible: e.target.value }))}
                onTooltipClick={() => modal.openModal(tooltips.comprehensiveDeductible.title, tooltips.comprehensiveDeductible.content)}
            />
            <DropdownRow
                display={["MI"].includes(policyStateAbbr)}
                name="collisionType"
                question='Choose your "Collision" type.*'
                options={<CollisionTypeList />}
                value={newVehicle.collisionType}
                onChange={(e) => setsCollision(e.target.value)}
                onTooltipClick={() => modal.openModal(tooltips.collisionOptions.title, tooltips.collisionOptions.content)}
            />
            <DropdownRow
                display={["MI"].includes(policyStateAbbr)}
                name="collisionDeductible"
                question='Choose your "Collision" coverage deductible.*'
                options={<CollisionDeductibleList newVehicle={newVehicle} />}
                value={newVehicle.collisionDeductible}
                onChange={(e) => setNewVehicle(prev => ({ ...prev, collisionDeductible: e.target.value }))}
                onTooltipClick={() => modal.openModal(tooltips.collisionDeductible.title, tooltips.collisionDeductible.content)}
            />
            <RadioButtonsRow
                display={["NJ"].includes(policyStateAbbr)}
                name="collisionDeductible"
                question='Choose your "Collision" coverage deductible.*'
                options={[
                    { value: "$750", label: "$750" }
                ]}
                noteContent={"If you are interested in a deductible other than the standard $750, you will be required to sign a new Coverage Selection Form. Please call 800-535-2873 to speak to a CURE representative."}
                alignItemsCenter={false}
                value={newVehicle.collisionDeductible}
                onChange={(e) => setNewVehicle(prev => ({ ...prev, collisionDeductible: e.target.value }))}
                onTooltipClick={() => modal.openModal(tooltips.collisionDeductible.title, tooltips.collisionDeductible.content)}
            />
            <RadioButtonsRow
                display={["PA"].includes(policyStateAbbr)}
                name="collisionDeductible"
                question='Choose your "Collision" coverage deductible.*'
                options={[
                    { value: "$500", label: "$500" }
                ]}
                noteContent={"If you are interested in a deductible other than the standard $500, you will be required to sign a new Coverage Selection Form. Please call 800-535-2873 to speak to a CURE representative."}
                alignItemsCenter={false}
                value={newVehicle.collisionDeductible}
                onChange={(e) => setNewVehicle(prev => ({ ...prev, collisionDeductible: e.target.value }))}
                onTooltipClick={() => modal.openModal(tooltips.collisionDeductible.title, tooltips.collisionDeductible.content)}
            />
            <DropdownRow
                display={["MI", "NJ"].includes(policyStateAbbr)}
                name="rentalCoverage"
                question="Rental Reimbursement*"
                options={rentalReimbursementOptions[policyStateAbbr]}
                value={newVehicle.rentalCoverage}
                onChange={(e) => setNewVehicle(prev => ({ ...prev, rentalCoverage: e.target.value }))}
                onTooltipClick={() => modal.openModal(tooltips.rentalReimbursement.title, tooltips.rentalReimbursement.content)}
            />
            <RadioButtonsRow
                display={["PA"].includes(policyStateAbbr)}
                name="rentalCoverage"
                question="Rental Reimbursement*"
                value={newVehicle.rentalCoverage}
                onChange={(e) => setNewVehicle(prev => ({ ...prev, rentalCoverage: e.target.value }))}
                onTooltipClick={() => modal.openModal(tooltips.rentalReimbursement.title, tooltips.rentalReimbursement.content)}
            />
            <RadioButtonsRow
                name="vehicleCustomization"
                question="Does this vehicle have modifications or customization?*"
                value={newVehicle.vehicleCustomization}
                onChange={(e) => setNewVehicle(prev => ({ ...prev, vehicleCustomization: e.target.value }))}
            />
            <RadioButtonsRow
                name="vehicleCommercial"
                question="Is this a commercial vehicle?*"
                value={newVehicle.vehicleCommercial}
                onChange={(e) => setNewVehicle(prev => ({ ...prev, vehicleCommercial: e.target.value }))}
            />
            <RadioButtonsRow
                name="vehicleCommercialPurposes"
                question="Is this vehicle used for commercial purposes, including but not limited to:"
                value={newVehicle.vehicleCommercialPurposes}
                onChange={(e) => setNewVehicle(prev => ({ ...prev, vehicleCommercialPurposes: e.target.value }))}
                indentedContent={
                    <>
                        a) limousine, taxi, or other delivery services other than through transportation network companies;<br />
                        b) in the business of pickup or delivery of magazines, newspapers, food, or any other products;<br />
                        c) and/or emergency services?*
                    </>
                }
            />
            <RadioButtonsRow
                name="leasedRentToOthers"
                question="Does the applicant or any other driver on the application lease or rent this vehicle to others?*"
                value={newVehicle.leasedRentToOthers}
                onChange={(e) => setNewVehicle(prev => ({ ...prev, leasedRentToOthers: e.target.value }))}
            />
            <RadioButtonsRow
                name="vehiclePlowSnow"
                question="Is this vehicle used to plow snow for compensation?*"
                value={newVehicle.vehiclePlowSnow}
                onChange={(e) => setNewVehicle(prev => ({ ...prev, vehiclePlowSnow: e.target.value }))}
            />
            {/* <RadioButtonsRow
                name="drivenExistingDriver"
                question={`Will this vehicle ${newVehicle.vehicleYear} ${newVehicle.vehicleMake} ${newVehicle.vehicleModel} ${newVehicle.vehicleVIN} be driven by an existing driver on your policy?*`}
                value={newVehicle.drivenExistingDriver}
                onChange={(e) => setNewVehicle(prev => ({ ...prev, drivenExistingDriver: e.target.value }))}
            /> */}
            <TooltipModal
                title={modal.modalTitle}
                msg={modal.modalMsg}
                show={modal.showModal}
                handleClose={modal.closeModal}
            />

            {policyStateAbbr === "NJ" &&
                <>
                    <hr className='helpful-divider' />
                    <div className='d-flex justify-content-center'>
                        <HelpfulDocumentsNJ policyType={context.userData.policyType} effectiveDate={newVehicle?.requestedCovEffDate}/>
                    </div>
                </>
            }
            {policyStateAbbr === "PA" &&
                <>
                    <hr className='helpful-divider' />
                    <div className='d-flex justify-content-center'>
                        <HelpfulDocumentsPA center={"center"} />
                    </div>
                </>
            }
        </form>
    )
}

export default EndorsementVehicleLeasedFinanced